import store from '../'

let resource = store.defineResource({
  name: "rubrics",
  computed: {
    maxScore: {
      get () {
        let criteria = this.criteria || []
        return this.score * criteria.length
      }
    },
    scoreRange: {
      get () {
        let start = this.zeroBased ? 0 : 1
        return _.range(start, this.score+1)
      }
    }
  }
})

export default resource



// WEBPACK FOOTER //
// ./src/store/models/rubrics.js